import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpDownLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpDownLeftRight"><Path d="M9 5.75L12 2.75L15 5.75" stroke="currentColor" strokeLinecap="square"/><Path d="M5.75 9L2.75 12L5.75 15" stroke="currentColor" strokeLinecap="square"/><Path d="M18.25 9L21.25 12L18.25 15" stroke="currentColor" strokeLinecap="square"/><Path d="M15 18.25L12 21.25L9 18.25" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3.5V12M12 12H3.5M12 12H20.5M12 12V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpDownLeftRight;
